<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <rank-division-picker
      :type="'currentRank'"
      item-key="rankBoosting"
      :title="$t('calculators_common.current_rank')"
      class="flex-5 flex-lg-10"
    />
    <DoubleRight />
    <rank-division-picker
      :type="'desiredRank'"
      item-key="rankBoosting"
      :prev-rank="getDetails.currentRank"
      :title="$t('calculators_common.desired_rank')"
      class="flex-5 flex-lg-10"
    />
  </div>
  <extra-option-picker />
  <option-picker />
</template>

<script setup>
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import { onMounted, watch } from "vue";

const {
  getDetails,
  setDetails,
  setPackExtraOptions,
  setServer,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack, getGameRanks } = useGameStore();

const handleDetails = () => {
  clearCheckout();

  if (getGameRanks.length > 0) {
    setDetails({
      currentDivision: getGameRanks[1]?.divisions[0]?.id,
      currentDivisionTitle: getGameRanks[1]?.divisions[0]?.title,
      currentRank: getGameRanks[1]?.id,
      currentRankTitle: getGameRanks[1]?.title,
      desiredDivision: getGameRanks[3]?.divisions[0]?.id,
      desiredDivisionTitle: getGameRanks[3]?.divisions[0]?.title,
      desiredRank: getGameRanks[3]?.id,
      desiredRankTitle: getGameRanks[3]?.title,
    });
  }

  setPackExtraOptions({
    currentLp: 113,
  });

  setServer("65");
  setPlatform({
    platform: 1,
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});
watch(
  () => getGameRanks,
  (newVal) => {
    setDetails({
      currentDivision: newVal[1]?.divisions[0]?.id,
      currentDivisionTitle: newVal[1]?.divisions[0]?.title,
      currentRank: newVal[1]?.id,
      currentRankTitle: newVal[1]?.title,
      desiredDivision: newVal[3]?.divisions[0]?.id,
      desiredDivisionTitle: newVal[3]?.divisions[0]?.title,
      desiredRank: newVal[3]?.id,
      desiredRankTitle: newVal[3]?.title,
    });
  }
);
</script>
